import { NgModule } from '@angular/core';
import { AlmUserName } from './alm-user-name.pipe';


export class AlmUserNameModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ AlmUserName ],
  exports: [ AlmUserName ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
